import React, { useEffect, useState } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import { useDispatch, useSelector } from "react-redux";
import { getTotalAshaAnmTableList, totalAshaAnmPaginationData } from "../../../../../Store/Dashboard/AshaAnmSection/AshaAnmSectionSelectors";
import { FilterMatchMode } from "primereact/api";
import SendReminderView from "../../../../../Shared/Component/SendReminder/SendReminderView";
import { Dropdown } from "primereact/dropdown";
import { fetchTotalAshaAnmData } from "../../../../../Store/Dashboard/AshaAnmSection/AshaAnmSectionActions";
import { Dialog } from "primereact/dialog";
import ModalHeader from "../../../../../Components/Header/ModalHeader";
import AshaIndividualView from "../../AshaIndividualView/AshaIndividualView";
import NoRecordFound from "../../../../../Shared/Component/NoRecordFound/NoRecordFound";
import CustomDataTable from "../../../../../Shared/Component/CustomTable/CustomDataTable";
import { AshaActiveInactiveColumns } from "../../../../../Shared/Constant/TableConstants";
import AnmIndividualView from "../../AnmIndividualView";
import * as dashboardselector from "../../../../../Store/Dashboard/DashboardSelectors";
import "./AshaAnmDetailsView.scss";
import { useLanguage } from "../../../../ChangeLanguage/LanguageProvider";
import { useTranslation } from "react-i18next";
import {
  ashaDetailFilterTemplate,
  buildSelectedIds,
  reminderBodyTemplate,
} from "../../../../../Shared/Utils/tableColumns";
const AshaAnmDetailsView = ({ index, totalActive, totalInactive }) => {
  const areaType = useSelector(dashboardselector.getGlobalAreaType);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const ashasData = useSelector(getTotalAshaAnmTableList);
  const paginationData = useSelector(totalAshaAnmPaginationData);
  const [tabIndex, setTabIndex] = useState(index);
  const instCol = AshaActiveInactiveColumns(tabIndex);
  const { selectedLanguageId } = useLanguage();
  const dispatch = useDispatch();
  const currentYr = new Date().getFullYear();
  const currentMonth = new Date().getMonth();
  const roles = ["ANM + Asha + AF", "Asha", "ANM","AF"];
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const [, setFilters] = useState(null);

  const [chosenMonth] = useState(months[currentMonth]);
  const [chosenYr] = useState(currentYr);
  const [chosenRole, setChosenRole] = useState("ANM + Asha");

  const [activeAshaList, setActiveAshaList] = useState([]);
  const [inactiveAshaList, setInactiveAshaList] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [isAshaViewVisible, setIsAshaViewVisible] = useState(false);
  const [chosenAshaId, setChosenAshaId] = useState("");
  const [chosenAnmId, setChosenAnmId] = useState("");
  const [chosenIndex, setChosenIndex] = useState(null);
  const [chosenAshaAnmRole, setChosenAshaAnmRole] = useState("");
  const [isAshaNameVisible, setIsAshaNameVisible] = useState("");
  const [, setIsAnmViewVisible] = useState(false);
  const { t } = useTranslation();
  const handleTabChange = ({ index }) => {
    setTabIndex(index);
    setSelectedItems([]);
    dispatch(
      fetchTotalAshaAnmData(
        areaType,
        chosenRole,
        chosenMonth,
        chosenYr,
        // chosenDistrict,
        selectedLanguageId,
        index,
        page,pageSize
      )
    );
  };

  const activeCasesFilterTemplate = (options) => {
    let casesList = [];
    const list = tabIndex === 0 ? activeAshaList : inactiveAshaList; // NOSONAR - Disabling rule for this line
    list.forEach((el) => {
      casesList.push(el.activeCases);
    });

    return (
      <Dropdown
        value={options.value}
        data-testid="activeCasesFilterTemplate"
        options={Array.from(new Set(casesList))}
        onChange={(e) => options.filterApplyCallback(e.value)}
        placeholder="Select / निवडा"
        showClear
      />
    );
  };

  const activitiesFilterTemplate = (options) => {
    let countList = [];
    const list = tabIndex === 0 ? activeAshaList : inactiveAshaList; // NOSONAR - Disabling rule for this line
    list.forEach((el) => {
      countList.push(el.totalActivityCount);
    });

    return (
      <Dropdown
        value={options.value}
        data-testid="activitiesFilterTemplate"
        options={Array.from(new Set(countList))}
        onChange={(e) => options.filterApplyCallback(e.value)}
        placeholder="Select / निवडा"
        showClear
      />
    );
  };
  const handleRoleChange = (val) => {
    setChosenRole(val);
    dispatch(
      fetchTotalAshaAnmData(
        areaType,
        val,
        chosenMonth,
        chosenYr,
        // chosenDistrict,
        selectedLanguageId,
        tabIndex,
        page,pageSize
      )
    );
  };

  const handleCellClick = (index, ashaId, role) => {
    setChosenAshaAnmRole(role);
    if (role === "ANM") {
      setChosenAnmId(ashaId);
    } else if (role === "Asha") {
      setChosenAshaId(ashaId);
    } else if (role === "AF") {
      setChosenAshaId(ashaId);
    }
    setIsAnmViewVisible(role === "ANM");
    setIsAshaViewVisible(role === "Asha");
    setIsAshaViewVisible(role === "AF");
    setChosenIndex(index);
  };
  const ashaDetailBodyTemplate = ({ ashaId, ashaName, role }) => {
    const handleCellClick = (index, ashaId, role, ashaName) => {
      setChosenAshaAnmRole(role);
      // if (role === "ANM") {
      //   setChosenAnmId(String(ashaId));
      // } else if (role === "ASHA") {
      //   setChosenAshaId(String(ashaId));
      //   setIsAshaNameVisible(ashaName);
      // }
      if (role === "ANM") {
        setChosenAnmId(String(ashaId));
      }
      else if (role === "ASHA") {
        setChosenAshaId(String(ashaId));
        setIsAshaNameVisible(ashaName);
      }
      else if (role === "AF") {
        setChosenAshaId(String(ashaId));   // ✅ same as ASHA
        setIsAshaNameVisible(ashaName);
      }
      setIsAshaViewVisible(true);
      setChosenIndex(index);
    };
    return (
      <div
        className="text-blue-600 font-normal cursor-pointer"
        onClick={() => handleCellClick(0, ashaId, role, ashaName)}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === "Space") {
            handleCellClick(0, ashaId, role, ashaName);
          }
        }}
        role="button"
        tabIndex={0}
      >
        {ashaName}
      </div>
    );
  };

  const ashaActivityBodyTemplate = ({ ashaId, totalActivityCount }) => {
    return (
      <div
        className="text-blue-600 font-normal cursor-pointer"
        onClick={() => handleCellClick(1, ashaId)}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === "Space") {
            handleCellClick(1, ashaId);
          }
        }}
        role="button"
        tabIndex={0}
      >
        {totalActivityCount}
      </div>
    );
  };

  const initFilters = () => {
    setFilters({
      ashaId: { value: "", matchMode: FilterMatchMode.CONTAINS },
      ashaName: { value: "", matchMode: FilterMatchMode.CONTAINS },
      role: { value: "", matchMode: FilterMatchMode.CONTAINS },
      contactNo: { value: "", matchMode: FilterMatchMode.CONTAINS },
      phcName: { value: null, matchMode: FilterMatchMode.EQUALS },
      joiningDate: { value: null, matchMode: FilterMatchMode.EQUALS },
      activeCases: { value: null, matchMode: FilterMatchMode.EQUALS },
      paidIncentive: { value: null, matchMode: FilterMatchMode.EQUALS },
      totalActivityCount: { value: null, matchMode: FilterMatchMode.EQUALS },
      reminderCount: { value: "", matchMode: FilterMatchMode.CONTAINS },
      inactiveSince: { value: null, matchMode: FilterMatchMode.EQUALS },
    });
  };

  const closeDialog = () => {
    setIsAshaViewVisible(false);
    setIsAnmViewVisible(false);
  };

  useEffect(() => {
    dispatch(
      fetchTotalAshaAnmData(
        areaType,
        chosenRole,
        chosenMonth,
        chosenYr,
        selectedLanguageId,
        tabIndex,
        page,pageSize
      )
    );
    initFilters();
  }, [areaType, page,pageSize]);

  useEffect(() => {
    if (ashasData) {
      let activeList = [];
      let inactiveList = [];
      ashasData.forEach((item) => {
        item.isActive ? activeList.push(item) : inactiveList.push(item);
      });
      setActiveAshaList(activeList);
      setInactiveAshaList(inactiveList);
    }
  }, [ashasData]);
  const filterMethods = {
    role: (options) => ashaDetailFilterTemplate(options, t),
    ashaName: (options) => ashaDetailFilterTemplate(options, t),
    ashaId: (options) => ashaDetailFilterTemplate(options, t),
    contactNo: (options) => ashaDetailFilterTemplate(options, t),
    joiningDate: (options) => ashaDetailFilterTemplate(options, t),
    activeCases: activeCasesFilterTemplate,
    totalActivityCount: activitiesFilterTemplate,
    reminderCount: (options) => ashaDetailFilterTemplate(options, t),
    inactiveSince: (options) => ashaDetailFilterTemplate(options, t),
    stateName: (options) => ashaDetailFilterTemplate(options, t),
    districtName: (options) => ashaDetailFilterTemplate(options, t),
    talukaName: (options) => ashaDetailFilterTemplate(options, t),
    phcName: (options) => ashaDetailFilterTemplate(options, t),
    subcenterName: (options) => ashaDetailFilterTemplate(options, t),
    villageName: (options) => ashaDetailFilterTemplate(options, t),
  };

  const bodyMethods = {
    ashaName: ashaDetailBodyTemplate,
    totalActivityCount: ashaActivityBodyTemplate,
    reminderCount: reminderBodyTemplate,
  };
  const handleTablePageChange = (newPage, newPageSize) => {
    setPage(newPage);
    setPageSize(newPageSize);
  };
  const activeInactiveData = (data, tabIndex) => {
    return (
      <>
        <CustomDataTable
          columns={instCol}
          data={data}
          dataKey="ashaId"
          selectedItems={selectedItems}
          onSelectionChange={(e) => setSelectedItems(e.value)}
          filterMethods={filterMethods}
          bodyMethods={bodyMethods}
          className="AshatableClass"
          page={page}
          pageSize={pageSize}
          onPageChange={handleTablePageChange}
          totalCount={paginationData?.totalCount}
        />
      </>
    );
  };
  return (
    <div className="asha-card">
      <div className="grid align-items-center justify-content-between">
        <div className="sm:col-12 md:col-10 lg:col-10 flex flex-wrap align-items-center">
          <p className="text-xl font-light ml-2">
            {t("totalashaanm")} :{ashasData ? (totalActive + totalInactive) : 0}
          </p>
          <div className="ml-2 mr-2">
            <Dropdown
              value={chosenRole}
              onChange={(e) => handleRoleChange(e.value)}
              options={roles}
              className="cockpit-dropdown"
              data-testid="role-test"
            />
          </div>
        </div>
        <div className="sm:col-12 md:col-2 lg:col-2">
          <SendReminderView
            ashaIds={buildSelectedIds(selectedItems)}
            isDisabled={selectedItems.length === 0}
            data-testid="send-reminder-button"
          />
        </div>
      </div>
      <TabView
        data-testid="tab-test"
        activeIndex={tabIndex}
        onTabChange={handleTabChange}
      >
        <TabPanel header={`${t("active")} ${totalActive}`}>
          {activeAshaList && totalActive > 0 ? (
            <div>
              {activeInactiveData(activeAshaList, tabIndex)}
            </div>
          ) : (
            <NoRecordFound />
          )}
        </TabPanel>
        <TabPanel header={`${t("inactive")} ${totalInactive}`}>
          {inactiveAshaList && totalInactive > 0 ? (
            <div>
              {activeInactiveData(inactiveAshaList, tabIndex)}
            </div>
          ) : (
            <NoRecordFound />
          )}
        </TabPanel>
      </TabView>
      <Dialog
        className="cockpit-dialog"
        visible={isAshaViewVisible}
        modal={true}
        position={"center"}
        draggable={false}
        resizable={false}
        onHide={() => {
          setIsAshaViewVisible(false);
          setIsAnmViewVisible(false);
        }}
        closeOnEscape={false}
        header={
          <ModalHeader onClose={closeDialog} backText={t("BacktoTable")} />
        }
      >
        {chosenAshaAnmRole === "ANM" && (
          <AnmIndividualView
            anmId={chosenAnmId}
            chosenActiveIndex={chosenIndex}
          />
        )}
        {chosenAshaAnmRole === "ASHA" && (
          <AshaIndividualView
            ashaId={chosenAshaId}
            chosenActiveIndex={chosenIndex}
            // isStatus={activeAshaList[chosenIndex].isActive}
            name={isAshaNameVisible}
          />
        )}
        {chosenAshaAnmRole === "AF" && (
          <AshaIndividualView
           afId={chosenAshaId}
            chosenActiveIndex={chosenIndex}
            name={isAshaNameVisible}
          />
        )}
      </Dialog>
    </div>
  );
};
export default AshaAnmDetailsView;
